import { useEffect, type RefObject } from 'react'

/** Moves focus after the opening pointer event finishes its default focus work. */
export function useSelectorSearchFocus({
  open,
  enabled,
  inputRef,
  positionKey,
}: {
  open: boolean
  enabled: boolean
  inputRef: RefObject<HTMLInputElement | null>
  positionKey?: unknown
}) {
  useEffect(() => {
    if (!open || !enabled) return
    const frameId = window.requestAnimationFrame(() => inputRef.current?.focus())
    return () => window.cancelAnimationFrame(frameId)
  }, [enabled, inputRef, open, positionKey])
}
